import '../scss/styles.scss';
import handleMenus from "./ScrollToSection"

export default function Footer() {
    return (
        <section className="footer">
            <div className="footer-top">
                <div className="footer-left">
                    <div className="menu-wrapper">
                        <ul>
                            <li><a href="#home" onClick={handleMenus}><h3>Faraway Sound Productions</h3></a></li>
                            <li><h4>Audio - Visual - Information Technology</h4></li>
                            <li><p>Our goal is to ensure that your next event is flawlessthat you spend less time worrying about the production quality and more time focusing on your guest’s satisfaction.</p></li>
                            <li><a href="#home" onClick={handleMenus}>Back to Top</a></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-right">
                    <div className="menu-wrapper">
                        <ul>
                            <li>
                                <a href="#services" onClick={handleMenus}>Services</a>
                                <p>Services include Audio & Visual Engineering, Information Technology, and
                                <span> <a href="#inquire" onClick={handleMenus}>Audio Equipment Rentals</a></span>.</p>
                            </li>
                            <li>
                                <a href="#inquire" onClick={handleMenus}>Equipment</a>
                                <p>Focusing on high quality PA systems, monitors, instruments, & backline equipment for bands.</p>
                            </li>
                            <li>
                                <a href="#about" onClick={handleMenus}>About</a>
                                <p>Providing a high-level of professional on-site service, support, and equipment for a wide variety of events.</p>
                            </li>
                            <li>
                                <a href="#contact" onClick={handleMenus}>Contact</a>
                                <p>Talk with one of our experts to see how Faraway Sound Productions can help.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <ul>
                    <li className="icons-container">
                        <a className="mail-btn"
                            href="#contact"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={handleMenus}
                        ></a>
                        <a className="mail"
                            href=""
                            target="_blank"
                            rel="noopener noreferrer"
                        ><span>PO Box 2717</span> Nantucket, MA  <span>02584</span></a>
                    </li>
                    <li className="icons-container">
                        <a className="call-btn"
                            href="tel:4062417299"
                            target="_blank"
                            rel="noopener noreferrer"
                        ></a>
                        <a className="call"
                            href="tel:4062417299"
                            target="_blank"
                            rel="noopener noreferrer"
                        >+1-406-241-7299</a>
                    </li>
                                    <li className="icons-container">
                        <a className="email-btn"
                            href="mailto: jwhite@farawaysoundproductions.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        ></a>
                        <a className="email"
                            href="mailto: jwhite@farawaysoundproductions.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >jwhite@farawaysoundproductions.com</a>
                    </li>
                </ul>
                <p>© 2023 Faraway Sound Productions, LLC. All rights reserved</p>
            </div>
        </section>
    )
}